import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../_metronic/layout";
import { ConnectionsStatusIndicator } from "../_metronic/layout/components/extras/ConnectionsStatusIndicator";
import { toAbsoluteUrl } from "../_metronic/_helpers";

const InspectionPage = lazy(() =>
  import("./modules/Inspection/pages/inspection/InspectionPage")
);

const divStyle = {
  width: "35%",
  height: "auto",
};
const divStyle2 = {
  width: "13%",
  height: "13%",
  objectFit: "contain",
};

export default function CleanPage() {
  const logo = toAbsoluteUrl(`/media/logos/logo-clean.png`);
  const logottam = toAbsoluteUrl(`/media/logos/logo-ttam.jpeg`);
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <div className="header  header-fluid">
        <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <div className="d-flex align-items-center flex-wrap mr-1">
            <img style={divStyle} src={logo} alt="MAX" />
          </div>
          <div className="d-flex align-items-center flex-wrap mr-1">
            <img style={divStyle2} src={logottam} alt="MAX" />
          </div>
          <div className="d-flex align-items-center">
            <ConnectionsStatusIndicator />
          </div>
        </div>
      </div>
      <Switch>
        <Redirect from="/clean" exact={true} to="/dashboard" />
        <Route path="/clean/inspection" component={InspectionPage} />
      </Switch>
    </Suspense>
  );
}
